import { Dialog, DialogContent, DialogTitle, FormLabel } from "@material-ui/core";
import { List, ListItem, ListItemText } from "@material-ui/core";
import moment from "moment";

export default function ShipRunDialog(props) {
  return (
    <Dialog
      open={props.visible}
      onClose={() => props.setVisible(false)}>
      <DialogTitle>Ship Run Details: {moment(props.shipRun?.insertedAt).format("MM/DD/YYYY, h:m A")}</DialogTitle>
      <DialogContent>
        <FormLabel>Shipment Numbers</FormLabel>
        <List dense={true} disablePadding={true}>
          {props.shipRunDetail?.shipShipments.map(sh =>
            <ListItem key={sh.shipShipmentId}>
              <ListItemText primary={sh.shipmentNumber}/>
            </ListItem>)}
        </List>
      </DialogContent>
    </Dialog>
  )
}
